module.exports = __webpack_public_path__ + "static/img/7.5139fd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/7.png
// module id = oYoN
// module chunks = 0